module.exports = __webpack_public_path__ + "static/media/postpaid_recharge.51c23322.svg";